// Allowed icon and tint values for an OttoPilot landing-screen template card. An allow-list
// rather than a Prisma enum because Postgres cannot drop an enum value and this list grows.

// Our own keys, not Kibble icon names, so a Kibble rename is absorbed in one map instead of
// invalidating stored rows. `Target` already differs: Kibble calls that icon `targetSolid`.
export const PROMPT_TEMPLATE_ICONS = [
  'DollarCircle',
  'Paw',
  'Report',
  'CalendarCheck',
  'Invoice',
  'TaskList',
  'CheckList',
  'Clock',
  'Team',
  'Health',
  'Target',
  'LightBulb',
] as const;

// Mirrors Kibble's Status set, so every value already has a background and text token pair.
export const PROMPT_TEMPLATE_ICON_COLORS = [
  'Default',
  'Info',
  'Success',
  'Warning',
  'Danger',
] as const;

export type PromptTemplateIcon = (typeof PROMPT_TEMPLATE_ICONS)[number];
export type PromptTemplateIconColor = (typeof PROMPT_TEMPLATE_ICON_COLORS)[number];
